// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import 'babel-polyfill'
import 'filepond-polyfill'
import Vue from 'vue'
import VueNativeSock from 'vue-native-websocket'
import './plugins/vuetify'
import VueSVGIcon from 'vue-svgicon'

import './filters'
import router from './router'
import store from './store'

import App from './App'

Vue.use(VueSVGIcon)
Vue.config.productionTip = false
Vue.config.app = process.env
Vue.config.app.sessionName = Vue.config.app.APP_NAME + 'Session'

const makeUrl = function (url) {
  // Support relative URLs
  let _url
  if (url[0] === '/') {
    // Use wss:// if running on https://
    const scheme = window.location.protocol === 'https:' ? 'wss' : 'ws'
    const baseUrl = `${scheme}://${window.location.host}`
    _url = `${baseUrl}${url}`
  } else {
    _url = url
  }
  return _url
}

Vue.use(VueNativeSock, makeUrl(Vue.config.app.WS_URL), {
  store: store,
  format: 'json',
  reconnection: true,
  reconnectionAttempts: 5,
  reconnectionDelay: 3000
})

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  template: '<App/>',
  components: { App }
})



// WEBPACK FOOTER //
// ./src/entrypoint.js